export const getcountryByName = (countryName)=>{

    if(!countryName){
      return "44"
    }
  
    let countryCodeObj = [
      {"country": "Afghanistan", "dialing_code": "+93"},
      {"country": "Albania", "dialing_code": "+355"},
      {"country": "Algeria", "dialing_code": "+213"},
      {"country": "Andorra", "dialing_code": "+376"},
      {"country": "Angola", "dialing_code": "+244"},
      {"country": "Argentina", "dialing_code": "+54"},
      {"country": "Armenia", "dialing_code": "+374"},
      {"country": "Australia", "dialing_code": "+61"},
      {"country": "Austria", "dialing_code": "+43"},
      {"country": "Azerbaijan", "dialing_code": "+994"},
      {"country": "Bahrain", "dialing_code": "+973"},
      {"country": "Bangladesh", "dialing_code": "+880"},
      {"country": "Belarus", "dialing_code": "+375"},
      {"country": "Belgium", "dialing_code": "+32"},
      {"country": "Belize", "dialing_code": "+501"},
      {"country": "Benin", "dialing_code": "+229"},
      {"country": "Bhutan", "dialing_code": "+975"},
      {"country": "Bolivia", "dialing_code": "+591"},
      {"country": "Bosnia and Herzegovina", "dialing_code": "+387"},
      {"country": "Botswana", "dialing_code": "+267"},
      {"country": "Brazil", "dialing_code": "+55"},
      {"country": "Brunei", "dialing_code": "+673"},
      {"country": "Bulgaria", "dialing_code": "+359"},
      {"country": "Burkina Faso", "dialing_code": "+226"},
      {"country": "Burundi", "dialing_code": "+257"},
      {"country": "Cambodia", "dialing_code": "+855"},
      {"country": "Cameroon", "dialing_code": "+237"},
      {"country": "Canada", "dialing_code": "+1"},
      {"country": "Cape Verde", "dialing_code": "+238"},
      {"country": "Central African Republic", "dialing_code": "+236"},
      {"country": "Chad", "dialing_code": "+235"},
      {"country": "Chile", "dialing_code": "+56"},
      {"country": "China", "dialing_code": "+86"},
      {"country": "Colombia", "dialing_code": "+57"},
      {"country": "Comoros", "dialing_code": "+269"},
      {"country": "Congo (DRC)", "dialing_code": "+243"},
      {"country": "Congo (Republic)", "dialing_code": "+242"},
      {"country": "Costa Rica", "dialing_code": "+506"},
      {"country": "Croatia", "dialing_code": "+385"},
      {"country": "Cuba", "dialing_code": "+53"},
      {"country": "Cyprus", "dialing_code": "+357"},
      {"country": "Czech Republic", "dialing_code": "+420"},
      {"country": "Denmark", "dialing_code": "+45"},
      {"country": "Djibouti", "dialing_code": "+253"},
      {"country": "Dominica", "dialing_code": "+1-767"},
      {"country": "Dominican Republic", "dialing_code": "+1-809"},
      {"country": "Ecuador", "dialing_code": "+593"},
      {"country": "Egypt", "dialing_code": "+20"},
      {"country": "El Salvador", "dialing_code": "+503"},
      {"country": "Equatorial Guinea", "dialing_code": "+240"},
      {"country": "Eritrea", "dialing_code": "+291"},
      {"country": "Estonia", "dialing_code": "+372"},
      {"country": "Eswatini", "dialing_code": "+268"},
      {"country": "Ethiopia", "dialing_code": "+251"},
      {"country": "Fiji", "dialing_code": "+679"},
      {"country": "Finland", "dialing_code": "+358"},
      {"country": "France", "dialing_code": "+33"},
      {"country": "Gabon", "dialing_code": "+241"},
      {"country": "Gambia", "dialing_code": "+220"},
      {"country": "Georgia", "dialing_code": "+995"},
      {"country": "Germany", "dialing_code": "+49"},
      {"country": "Ghana", "dialing_code": "+233"},
      {"country": "Greece", "dialing_code": "+30"},
      {"country": "Grenada", "dialing_code": "+1-473"},
      {"country": "Guatemala", "dialing_code": "+502"},
      {"country": "Guinea", "dialing_code": "+224"},
      {"country": "Guinea-Bissau", "dialing_code": "+245"},
      {"country": "Guyana", "dialing_code": "+592"},
      {"country": "Haiti", "dialing_code": "+509"},
      {"country": "Honduras", "dialing_code": "+504"},
      {"country": "Hungary", "dialing_code": "+36"},
      {"country": "Iceland", "dialing_code": "+354"},
      {"country": "India", "dialing_code": "+91"},
      {"country": "Indonesia", "dialing_code": "+62"},
      {"country": "Iran", "dialing_code": "+98"},
      {"country": "Iraq", "dialing_code": "+964"},
      {"country": "Ireland", "dialing_code": "+353"},
      {"country": "Israel", "dialing_code": "+972"},
      {"country": "Italy", "dialing_code": "+39"},
      {"country": "Jamaica", "dialing_code": "+1-876"},
      {"country": "Japan", "dialing_code": "+81"},
      {"country": "Jordan", "dialing_code": "+962"},
      {"country": "Kazakhstan", "dialing_code": "+7"},
      {"country": "Kenya", "dialing_code": "+254"},
      {"country": "Kiribati", "dialing_code": "+686"},
      {"country": "Kuwait", "dialing_code": "+965"},
      {"country": "Kyrgyzstan", "dialing_code": "+996"},
      {"country": "Laos", "dialing_code": "+856"},
      {"country": "Latvia", "dialing_code": "+371"},
      {"country": "Lebanon", "dialing_code": "+961"},
      {"country": "Lesotho", "dialing_code": "+266"},
      {"country": "Liberia", "dialing_code": "+231"},
      {"country": "Libya", "dialing_code": "+218"},
      {"country": "Liechtenstein", "dialing_code": "+423"},
      {"country": "Lithuania", "dialing_code": "+370"},
      {"country": "Luxembourg", "dialing_code": "+352"},
      {"country": "Madagascar", "dialing_code": "+261"},
      {"country": "Malawi", "dialing_code": "+265"},
      {"country": "Malaysia", "dialing_code": "+60"},
      {"country": "Maldives", "dialing_code": "+960"},
      {"country": "Mali", "dialing_code": "+223"},
      {"country": "Malta", "dialing_code": "+356"},
      {"country": "Marshall Islands", "dialing_code": "+692"},
      {"country": "Mauritania", "dialing_code": "+222"},
      {"country": "Mauritius", "dialing_code": "+230"},
      {"country": "Mexico", "dialing_code": "+52"},
      {"country": "Micronesia", "dialing_code": "+691"},
      {"country": "Moldova", "dialing_code": "+373"},
      {"country": "Monaco", "dialing_code": "+377"},
      {"country": "Mongolia", "dialing_code": "+976"},
      {"country": "Montenegro", "dialing_code": "+382"},
      {"country": "Morocco", "dialing_code": "+212"},
      {"country": "Mozambique", "dialing_code": "+258"},
      {"country": "Myanmar", "dialing_code": "+95"},
      {"country": "Namibia", "dialing_code": "+264"},
      {"country": "Nauru", "dialing_code": "+674"},
      {"country": "Nepal", "dialing_code": "+977"},
      {"country": "Netherlands", "dialing_code": "+31"},
      {"country": "New Zealand", "dialing_code": "+64"},
      {"country": "Nicaragua", "dialing_code": "+505"},
      {"country": "Niger", "dialing_code": "+227"},
      {"country": "Nigeria", "dialing_code": "+234"},
      {"country": "North Korea", "dialing_code": "+850"},
      {"country": "North Macedonia", "dialing_code": "+389"},
      {"country": "Norway", "dialing_code": "+47"},
      {"country": "Oman", "dialing_code": "+968"},
      {"country": "Pakistan", "dialing_code": "+92"},
      {"country": "Palau", "dialing_code": "+680"},
      {"country": "Panama", "dialing_code": "+507"},
      {"country": "Papua New Guinea", "dialing_code": "+675"},
      {"country": "Paraguay", "dialing_code": "+595"},
      {"country": "Peru", "dialing_code": "+51"},
      {"country": "Philippines", "dialing_code": "+63"},
      {"country": "Poland", "dialing_code": "+48"},
      {"country": "Portugal", "dialing_code": "+351"},
      {"country": "Qatar", "dialing_code": "+974"},
      {"country": "Romania", "dialing_code": "+40"},
      {"country": "Russia", "dialing_code": "+7"},
      {"country": "Rwanda", "dialing_code": "+250"},
      {"country": "Saint Kitts and Nevis", "dialing_code": "+1-869"},
      {"country": "Saint Lucia", "dialing_code": "+1-758"},
      {"country": "Saint Vincent and the Grenadines", "dialing_code": "+1-784"},
      {"country": "Samoa", "dialing_code": "+685"},
      {"country": "San Marino", "dialing_code": "+378"},
      {"country": "Sao Tome and Principe", "dialing_code": "+239"},
      {"country": "Saudi Arabia", "dialing_code": "+966"},
      {"country": "Senegal", "dialing_code": "+221"},
      {"country": "Serbia", "dialing_code": "+381"},
      {"country": "Seychelles", "dialing_code": "+248"},
      {"country": "Sierra Leone", "dialing_code": "+232"},
      {"country": "Singapore", "dialing_code": "+65"},
      {"country": "Slovakia", "dialing_code": "+421"},
      {"country": "Slovenia", "dialing_code": "+386"},
      {"country": "Solomon Islands", "dialing_code": "+677"},
      {"country": "Somalia", "dialing_code": "+252"},
      {"country": "South Africa", "dialing_code": "+27"},
      {"country": "South Korea", "dialing_code": "+82"},
      {"country": "South Sudan", "dialing_code": "+211"},
      {"country": "Spain", "dialing_code": "+34"},
      {"country": "Sri Lanka", "dialing_code": "+94"},
      {"country": "Sudan", "dialing_code": "+249"},
      {"country": "Suriname", "dialing_code": "+597"},
      {"country": "Sweden", "dialing_code": "+46"},
      {"country": "Switzerland", "dialing_code": "+41"},
      {"country": "Syria", "dialing_code": "+963"},
      {"country": "Taiwan", "dialing_code": "+886"},
      {"country": "Tajikistan", "dialing_code": "+992"},
      {"country": "Tanzania", "dialing_code": "+255"},
      {"country": "Thailand", "dialing_code": "+66"},
      {"country": "Togo", "dialing_code": "+228"},
      {"country": "Tonga", "dialing_code": "+676"},
      {"country": "Trinidad and Tobago", "dialing_code": "+1-868"},
      {"country": "Tunisia", "dialing_code": "+216"},
      {"country": "Turkey", "dialing_code": "+90"},
      {"country": "Turkmenistan", "dialing_code": "+993"},
      {"country": "Tuvalu", "dialing_code": "+688"},
      {"country": "Uganda", "dialing_code": "+256"},
      {"country": "Ukraine", "dialing_code": "+380"},
      {"country": "United Arab Emirates", "dialing_code": "+971"},
      {"country": "United Kingdom", "dialing_code": "+44"},
      {"country": "United States", "dialing_code": "+1"},
      {"country": "Uruguay", "dialing_code": "+598"},
      {"country": "Uzbekistan", "dialing_code": "+998"},
      {"country": "Vanuatu", "dialing_code": "+678"},
      {"country": "Vatican City", "dialing_code": "+379"},
      {"country": "Venezuela", "dialing_code": "+58"},
      {"country": "Vietnam", "dialing_code": "+84"},
      {"country": "Yemen", "dialing_code": "+967"},
      {"country": "Zambia", "dialing_code": "+260"},
      {"country": "Zimbabwe", "dialing_code": "+263"}
    ]
  
    let data = countryCodeObj.filter((eachcountryObj)=>{
        return eachcountryObj.country.toLowerCase() == countryName.toLowerCase()
    })
  
    if(data.length == 0){
      return "44"
    }
  
    return data[0].dialing_code.split('+')[1]
  
  }

export const experianConfig = ()=>{
  let data = {
    DATA: [
      {
        countryIso: 'GBR',
        countryName: 'UNITED KINGDOM',
        // dataset: 'gb-address',
        id: 1,
        maxSuggestion: 100
      },
      {
        countryIso: 'IRL',
        countryName: 'IRELAND',
        // dataset: 'ie-address-ecad',
        id: 2,
        maxSuggestion: 100
      }
    ]
  }
  return data
}
